import React, { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  FileInput,
  FileField,
  BooleanInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  FormDataConsumer,
} from "react-admin";
import { Typography } from "@mui/material";
import { CustomFile, EmptyFiles } from "components/features/Partials/CustomComponents/CustomFile";
import { languageChoices, buyerProfileType } from "../../../../utils/options";
import { ActiveEditToolbar } from "../../Partials/CustomComponents/ActiveSaveToolbar";
import { arrayLabel, editTitle } from "../../../../customStyles/ra-custom-styles";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const EditBuyerProfiles = () => {
  const [filesToDelete, setFilesToDelete] = useState([]);
  const handleChange = id => {
    if (filesToDelete.includes(id)) {
      setFilesToDelete([...filesToDelete.filter(item => item !== id)]);
    } else {
      setFilesToDelete([...filesToDelete, id]);
    }
  };
  const transform = data => ({
    ...data,
    delete_files_ids: [...filesToDelete],
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });
  return (
    <Edit
      mutationMode="pessimistic"
      sx={editTitle}
      transform={transform}
    >
      <Typography sx={editTitle}>Редакция на профил на купувач </Typography>
      <SimpleForm toolbar={<ActiveEditToolbar />}>
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />
        <SelectInput
          label="Тип обява"
          source="buyer_profile_type"
          choices={buyerProfileType}
          fullWidth
          validate={required()}
        />
        <TextInput
          label="Заглавие"
          source="title"
          fullWidth
          multiline
        />
        <CustomDateInput
          label="Дата на публикуване"
          source="started_on"
        />

        <BooleanInput
          label="Скрита"
          source="is_hidden"
        />

        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (formData.buyer_profile_files?.length === 0) {
              return <EmptyFiles />;
            } else {
              return (
                <CustomFile
                  data={formData.buyer_profile_files}
                  handleChange={handleChange}
                  filesToDelete={filesToDelete}
                />
              );
            }
          }}
        </FormDataConsumer>
        <ArrayInput
          source="files"
          label="Качете файл"
          sx={arrayLabel}
        >
          <SimpleFormIterator disableReordering>
            <FileInput
              placeholder="Кликнете за да добавите файл"
              label="Документация"
              source="file"
              maxSize={54525952}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
            <TextInput
              label="Име на файла"
              source="name"
              fullWidth
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export default EditBuyerProfiles;
